import * as React from "react";

import { StyledCheckbox } from "./style";

type Props = React.HTMLProps<HTMLInputElement>;

const handleWrapper = (Component: any) =>
  React.forwardRef(
    (props: Props, ref: React.ForwardedRef<HTMLInputElement>) => {
      return <Component {...props} ref={ref} />;
    }
  );

export const Checkbox = handleWrapper(StyledCheckbox);
